import React from 'react';

const AdColumn = ({ position = 'left' }) => {
  return (
    <aside className={`ad-column ${position}-ad`}>
      <div className="ad-placeholder">
        <p>Google AdSense</p>
        <p>160x600</p>
        <p>{position === 'left' ? 'Left Ad' : 'Right Ad'}</p>
        {/* Replace with actual AdSense code:
        <ins className="adsbygoogle"
             style={{display:'block'}}
             data-ad-client="ca-pub-XXXXXXXXXX"
             data-ad-slot="XXXXXXXXXX"></ins>
        */}
      </div>
    </aside>
  );
};

export default AdColumn;